import { ILayerConfig } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

// Returns tileset filters that apply globally to the entire map layer
//   (This means this filter applies to all features / all LayerValues in the map layer)
export const getMapboxFilters = (
  uniqueFilters: Record<string, ILayerConfig[]>
): { filter?: ExpressionSpecification } => {
  const allFilterJsons = Object.keys(uniqueFilters)
  if (allFilterJsons.includes('none') || allFilterJsons.length === 0) {
    // If any/all LayerValues have undefined filters,
    //   this indicates all features should be styled by the LayerValue.
    //   No global filter should be used.
    return {}
  }
  if (allFilterJsons.length === 1) {
    // Single filter for all LayerValues
    return { filter: uniqueFilters[allFilterJsons[0]][0].filter }
  }
  if (allFilterJsons.length > 1) {
    // If all LayerValues contain filters, and there are >1 unique filters,
    //   this indicates that only the filtered features have styling and should show.
    //   All other features should be filtered out.
    // Combine unique filters into 1 mapbox expression.
    return {
      filter: [
        'any',
        ...allFilterJsons.map((json) => uniqueFilters[json][0].filter)
      ]
    }
  }
  return {}
}
